import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { JeeVerificationService } from '../jee-verification.service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as Tesseract from 'tesseract.js';
import { GlobalWorkerOptions, getDocument } from 'pdfjs-dist';

// Polyfill for Promise.withResolvers which is required by pdfjs-dist v4+
// but might be missing in some environments (like older browsers or Node versions).
if (typeof (Promise as any).withResolvers === 'undefined') {
  (Promise as any).withResolvers = function () {
    let resolve, reject;
    const promise = new Promise((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

@Component({
  selector: 'app-jee-mains-verification',
  templateUrl: './jee-mains-verification.component.html',
  styleUrls: ['./jee-mains-verification.component.scss']
})
export class JeeMainsVerificationComponent implements OnInit {
  // matchStatus: boolean | null = null;
  matchStatus: {
    applicationNo: boolean | null,
    studentName: boolean | null,
    dob: boolean | null,
    parentName: boolean | null,
    displayGender: boolean | null,
    motherName: boolean | null
  } = {
      applicationNo: null,
      studentName: null,
      dob: null,
      parentName: null,
      displayGender: null,
      motherName: null
    };

  displayGender: string = '';

  searchCriteria: any;
  studentDetails: any;
  filteredSearchDetails: any;
  searchDetails: any;
  showDropdown: boolean = false;
  referred: any;

  studentName: any = '';
  parentName: any = '';
  campusName: any = '';
  cityName: any = '';
  buildingName: any = '';
  // dob: any = '';
  gender: any = '';
  studentEmail: any = '';
  sponseredBy: any = '';
  programName: any = '';
  className: any = '';
  streanName: any = '';
  jeeMainsApplicationNo: any = '';
  mobileNo: any = '';
  jeeMainsPassword: any = '';
  VitPassword: any = '';
  VitHtno: any = '';

  // uploaded file list //
  govtApplicationNo: any = '';
  govtcandidateName: any = '';
  govtfatherName: any = '';
  govtDB: any = '';
  govtGender: any = '';
  govtNationality: any = '';
  govtmotherName: any = '';

  // selectedPdf!: File;
  showPdf: any = true;

  // new feature //
  ocrText: string = '';
  loading: boolean = false;
  imageBase64: string = '';

  // Extracted fields
  applicationNumber: string = '';
  candidateName: string = '';
  dob: string = '';
  motherName: string = '';
  fatherName: string = '';

    selectedPdf: File | null = null;
  uploadProgress: number = 0;
  uploading: boolean = false;


  constructor(private service: JeeVerificationService, private eRef: ElementRef, private spinner: NgxSpinnerService,) {
    GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.8.69/pdf.worker.min.mjs';
  }
  ngOnInit(): void {

  }

  onKeyUp(event: any) {
    const inputValue = event.target.value;
    if (!inputValue) {
      this.filteredSearchDetails = [];
    }
    else if (inputValue.length > 5) {
      const selectedlist = inputValue;
      this.getstudentSearch(selectedlist);
    }
  }

  onKeyDown(event: any) {
    if (event.key === 'Enter') {
      this.getstudentSearch(this.searchCriteria);
    }
  }

  getstudentSearch(selectedlist: any) {
    this.spinner.show();
    this.service.getSearchJeeMains(selectedlist).subscribe({
      next: (res: any) => {
        if (!res || (Array.isArray(res) && res.length === 0)) {
          this.spinner.hide();
          return
        }
        this.searchDetails = res;
        this.filteredSearchDetails = res;
        this.showDropdown = this.searchDetails.length > 0;
        console.log('res', res);
        this.spinner.hide();
      },
      error: (err: any) => {
        this.spinner.hide();
        console.log('err', err);

      }
    })
  }

  selectItem(item: any) {
    console.log('item', item);
    this.searchCriteria = item.admNo;
    this.searchDetails = [];
    this.filteredSearchDetails = [];
    this.showDropdown = false;
    this.studentList();
  }

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: MouseEvent) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.showDropdown = true;
      this.searchDetails = [];
      this.filteredSearchDetails = [];
    }
  }

  studentList() {
    this.spinner.show();
    this.service.getStudentList(this.searchCriteria).subscribe({
      next: (res: any) => {
        console.log('studentList', res);
        this.studentName = res.studentName;
        this.parentName = res.parentName;
        this.campusName = res.campusName;
        this.cityName = res.cityName;
        this.buildingName = res.buildingName;
        this.sponseredBy = res.sponseredBy;
        this.className = res.className;
        this.streanName = res.streanName
        this.programName = res.programName;
        this.jeeMainsApplicationNo = res.jeeMainsApplicationNo;
        this.mobileNo = res.mobileNo;
        this.jeeMainsPassword = res.jeeMainsPassword;
        this.VitPassword = res.VitPassword;
        this.VitHtno = res.VitHtno;

        const apiDob = res.dob; // "Apr 3, 2009, 12:00:00 AM"
        const dateObj = new Date(apiDob);
        const day = dateObj.getDate();
        const month = ('0' + (dateObj.getMonth() + 1)).slice(-2);
        const year = dateObj.getFullYear();
        this.dob = `${day}-${month}-${year}`;
        this.studentEmail = res.studentEmail;
        this.gender = res.gender;
        if (this.gender === 'F') {
          this.displayGender = 'FEMALE';
        }
        else if (this.gender === 'M') {
          this.displayGender = 'MALE';
        }
        this.checkApplicationNo();
        this.spinner.hide();
      },
      error: (err: any) => {
        this.spinner.hide();
        console.log('ERROR', err);
      }
    })
  }

  // onPdfSelect(event: any) {
  //   const file = event.target.files[0];
  //   if (file && file.type === 'application/pdf') {
  //     this.selectedPdf = file;
  //   }
  // }

  onPdfSelect(event: Event) {
  const input = event.target as HTMLInputElement;

  if (!input.files || input.files.length === 0) {
    return;
  }

  const file = input.files[0];

  // Validate PDF
  if (file.type !== 'application/pdf') {
    alert('Please upload a valid PDF file');
    input.value = '';
    return;
  }

  this.selectedPdf = file;

  // 🔥 Directly call API after select
  this.uploadPdf(file);

  // Reset input so same file can be selected again
  input.value = '';
}

uploadPdf(file: File) {
  this.spinner.show();

  this.service.studentPdfUpload(file)
    .subscribe({
      next: (res: any) => {
        console.log('PDF upload success', res);
        this.spinner.hide();

        // Example: assign response data
        // this.govtApplicationNo = res['Application Number'];
      },
      error: (err: any) => {
        this.spinner.hide();
        console.error('PDF upload failed', err);
      }
    });
}


  // studentPdfUpload() {
  //   if (!this.selectedPdf) return;
  //   this.spinner.show();
  //   this.service.studentPdfUpload(this.selectedPdf)
  //     .subscribe({
  //       next: (res: any) => {
  //         this.showPdf = false;
  //         this.govtApplicationNo = res['Application Number']
  //         this.govtcandidateName = res['Candidate Name']
  //         this.govtDB = res['Date of Birth']
  //         this.govtfatherName = res['Father Name']
  //         this.govtGender = res['Gender']
  //         this.govtmotherName = res['Mother Name']
  //         this.govtNationality = res['Nationality']
  //         console.log('PDF upload success', res);
  //         this.spinner.hide();
  //       },
  //       error: (err: any) => {
  //         this.spinner.hide();
  //         console.error('PDF upload failed', err);
  //       }
  //     });
  // }


  async onFileSelected(event: any) {
    const file = event.target.files[0];
    if (!file) return;

    if (file.type !== 'application/pdf') {
      alert('Please upload a valid PDF file.');
      return;
    }

    this.loading = true;
    this.resetFields();

    try {
      const arrayBuffer = await file.arrayBuffer();
      const pdf = await getDocument({ data: arrayBuffer }).promise;
      const page = await pdf.getPage(1);

      // 🔼 Higher scale = better OCR
      const scale = 4.0;
      const viewport = page.getViewport({ scale });

      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      if (!context) throw new Error('Canvas context not found');

      // ✅ Use devicePixelRatio for sharp rendering
      const outputScale = window.devicePixelRatio || 1;

      canvas.width = Math.floor(viewport.width * outputScale);
      canvas.height = Math.floor(viewport.height * outputScale);

      canvas.style.width = `${viewport.width}px`;
      canvas.style.height = `${viewport.height}px`;

      context.setTransform(outputScale, 0, 0, outputScale, 0, 0);

      // 🖨️ Print-quality rendering
      await page.render({
        canvasContext: context,
        viewport,
        intent: 'print'
      }).promise;

      // 🎯 OPTIONAL: grayscale preprocessing (boosts OCR accuracy)
      const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;

      for (let i = 0; i < data.length; i += 4) {
        const gray = data[i] * 0.3 + data[i + 1] * 0.59 + data[i + 2] * 0.11;
        data[i] = data[i + 1] = data[i + 2] = gray;
      }

      context.putImageData(imageData, 0, 0);

      // ✅ Convert to high-quality PNG
      this.imageBase64 = canvas.toDataURL('image/png');

      await this.runOCR(this.imageBase64);

    } catch (error) {
      console.error('Error processing PDF:', error);
      this.loading = false;
    }
  }

  async runOCR(image: string) {
    try {
      const result = await Tesseract.recognize(image, 'eng', {
        logger: m => console.log(m)
      });

      this.ocrText = result.data.text;
      this.parseFields(this.ocrText);
    } catch (err) {
      console.error('OCR Error:', err);
    } finally {
      this.loading = false;
    }
  }

  resetFields() {
    this.ocrText = '';
    this.imageBase64 = '';
    this.govtApplicationNo = '';
    this.govtcandidateName = '';
    this.govtDB = '';
    this.govtmotherName = '';
    this.govtfatherName = '';
    this.govtGender = '';
  }

  fixName(name: string): string {
    let fixed = name.trim();
    fixed = fixed.replace(/0/g, 'O');
    fixed = fixed.replace(/1/g, 'I');
    fixed = fixed.replace(/\|/g, 'I');
    fixed = fixed.replace(/\$/g, 'S');
    fixed = fixed.replace(/[®©]/g, ''); // Remove common symbol noise
    return fixed.toUpperCase();
  }

  /**
   * Specifically cleans common OCR artifacts and label overlap from extracted names.
   */
  private cleanNameNoise(name: string): string {
    // 1. Convert to Uppercase for consistent noise matching
    let cleaned = this.fixName(name);

    // 2. Remove common trailing noise words (PTA, FO, GAAN, etc.)
    // These are often misreads of labels or boundary markers.
    const noiseWords = ['PTA', 'FO', 'GAAN', 'TEGA', 'FER', 'GO', 'FE', 'AN', 'AT'];
    const parts = cleaned.split(/\s+/);

    // Filter from the end: keep removing if the last word is in our noise list
    while (parts.length > 0) {
      const lastWord = parts[parts.length - 1];
      if (noiseWords.includes(lastWord) || lastWord.length <= 1) {
        parts.pop();
      } else {
        break;
      }
    }

    return parts.join(' ').trim();
  }

  cleanName(line: string): string {
    let cleaned = line
      .replace(/\(.+$/, '')
      .replace(/[0-9!@#$%^&*()_=+\[\]{};:'",.<>?\\|`~]/g, '') // Keep spaces
      .replace(/\s+/g, ' ')
      .trim();
    return cleaned;
  }

  // parseFields(text: string) {
  //   // Normalize line endings and join lines for a more global search
  //   const normalizedText = text.replace(/\r/g, '');
  //   const lines = normalizedText.split('\n').map(l => l.trim()).filter(l => l);

  //   for (let i = 0; i < lines.length; i++) {
  //     const line = lines[i];

  //     // 1. Application Number
  //     if (!this.govtApplicationNo) {
  //       const match = line.match(/Application\s*Number.*?(\d{8,15})/i);
  //       if (match) this.govtApplicationNo = match[1];
  //     }
  //     // 2. Candidate Name
  //     // Common boundaries to STOP name extraction
  //     const boundaries =
  //       'FATHER|MOTHER|GENDER|DATE|DOB|CATEGORY|STATE|ROLL|APP|APPLICATION|PERSON|SCRIBE|SIGNATURE|PHOTO|RESULT|RANK|REGISTRATION';

  //     /* ================= CANDIDATE NAME ================= */
  //     const candidateRegex = new RegExp(
  //       "(?:CANDIDATE(?:'S)?\\s*NAME)[:\\s\\)-]*([A-Z\\s]{3,}?)(?=\\s*(?:" + boundaries + "|$))",
  //       'i'
  //     );

  //     const candidateMatch = normalizedText.match(candidateRegex);
  //     if (candidateMatch && candidateMatch[1]) {
  //       this.govtcandidateName = this.cleanNameNoise(candidateMatch[1]);
  //     }

  //     // 3. Date of Birth (DOB)
  //     if (!this.govtDB) {
  //       const m = line.match(/\b(\d{2}-\d{2}-\d{4})\b/);
  //       if (m) this.govtDB = m[1];
  //     }

  //     // 4. Mother Name
  //     if (!this.govtmotherName) {
  //       // Capture everything until the next parenthesis or colon or end of line
  //       const regex = /Mother(?:'s|\s*\/\s*Guardian\s*Name)[\s:\)-]*([^(\n:]+)/i;
  //       const match = line.match(regex);
  //       if (match) {
  //         const rawValue = match[1];
  //         const cleaned = this.cleanNameNoise(rawValue);
  //         if (cleaned.length > 2) this.govtmotherName = cleaned;
  //       }
  //     }

  //     // 5. Father Name
  //     // if (!this.govtfatherName) {
  //     //   const regex = /Father(?:'s|\s*\/\s*Guardian\s*Name)[\s:\)-]*([^(\n:]+)/i;
  //     //   const match = line.match(regex);
  //     //   if (match) {
  //     //     let namePart = match[1];

  //     //     // Check if name continues on next line (common in NTA forms)
  //     //     if (i + 1 < lines.length) {
  //     //       const nextLine = lines[i + 1];
  //     //       // If next line doesn't start with a label (check for parenthesis/colon)
  //     //       if (!nextLine.includes('(') && !nextLine.includes(':') && /^[A-Z]/.test(nextLine)) {
  //     //         namePart += ' ' + nextLine;
  //     //       }
  //     //     }

  //     //     const cleaned = this.cleanNameNoise(namePart);
  //     //     if (cleaned.length > 2) this.govtfatherName = cleaned;
  //     //   }
  //     // }

  //     // Father Name
  //     if (!this.govtfatherName) {
  //       const m = line.match(/FATHER'?S\s*NAME\s*[:\s]*([A-Z\s]+)/i);
  //       if (m) this.govtfatherName = this.cleanName(m[1]);
  //     }

  //     // 6. Gender
  //     // if (!this.govtGender) {
  //     //   const match = line.match(/\(Gender\)\s*([A-Za-z]+)/i);
  //     //   if (match) this.govtGender = match[1].toUpperCase();
  //     // }

  //     // 6. Gender
  //     if (!this.govtGender) {
  //       const match = line.match(/Gender\s*[:\s]*([A-Za-z]+)/i);
  //       if (match) {
  //         this.govtGender = match[1].toUpperCase();
  //       }
  //     }


  //     // 7. Nationality
  //     // if (!this.govtNationality) {
  //     //   const match = line.match(/\(Nationality\)\s*([A-Za-z]+)/i);
  //     //   if (match) this.govtNationality = match[1].toUpperCase();
  //     // }

  //   }
  //   this.checkApplicationNo();
  // }


  // checkApplicationNo() {
  //   if (!this.jeeMainsApplicationNo || !this.govtApplicationNo) {
  //     this.matchStatus = null;
  //     return;
  //   }

  //   this.matchStatus =
  //     this.jeeMainsApplicationNo.trim() === this.govtApplicationNo.trim();
  // }



  parseFields(text: string) {

    /* ================= NORMALIZE OCR TEXT ================= */
    const normalizedText = text
      .replace(/\r/g, '')
      .replace(/\n+/g, ' ')
      .toUpperCase();

    const lines = text
      .replace(/\r/g, '')
      .split('\n')
      .map(l => l.trim())
      .filter(Boolean);

    /* ================= STOP WORDS ================= */
    const boundaries =
      'FATHER|MOTHER|GENDER|DATE|DOB|CATEGORY|STATE|ROLL|APP|APPLICATION|PERSON|SCRIBE|SIGNATURE|PHOTO|RESULT|RANK|REGISTRATION';

    /* ================= APPLICATION NUMBER ================= */
    if (!this.govtApplicationNo) {
      const m = normalizedText.match(/APPLICATION\s*NUMBER\s*(\d{8,15})/i);
      if (m) this.govtApplicationNo = m[1];
    }

    /* ================= CANDIDATE NAME ================= */
    if (!this.govtcandidateName) {
      const candidateRegex = new RegExp(
        "(?:CANDIDATE(?:'S)?\\s*NAME)[:\\s\\)-]*([A-Z\\s]{3,}?)(?=\\s*(?:" + boundaries + "|$))",
        'i'
      );

      const m = normalizedText.match(candidateRegex);
      if (m && m[1]) {
        this.govtcandidateName = this.cleanNameNoise(m[1]);
      }
    }

    /* ================= FATHER NAME (MULTI-LINE SAFE) ================= */
    if (!this.govtfatherName) {
      const fatherRegex = new RegExp(
        "(?:FATHER(?:'S)?\\s*NAME)[:\\s\\)-]*([A-Z\\s]{3,}?)(?=\\s*(?:" + boundaries + "|$))",
        'i'
      );

      const m = normalizedText.match(fatherRegex);
      if (m && m[1]) {
        this.govtfatherName = this.cleanNameNoise(m[1]);
      }
    }

    /* ================= DOB ================= */
    if (!this.govtDB) {
      const m = normalizedText.match(/\b\d{2}-\d{2}-\d{4}\b/);
      if (m) this.govtDB = m[0];
    }

    /* ================= GENDER ================= */
    if (!this.govtGender) {
      const m = normalizedText.match(/GENDER\s*[:\s]*([A-Z]+)/i);
      if (m) this.govtGender = m[1].toUpperCase();
    }

    this.checkApplicationNo();
  }


  checkApplicationNo() {
    // Application No check
    if (this.jeeMainsApplicationNo && this.govtApplicationNo) {
      this.matchStatus.applicationNo =
        this.jeeMainsApplicationNo.trim() === this.govtApplicationNo.trim();
    } else {
      this.matchStatus.applicationNo = null;
    }

    // Student Name check
    if (this.studentName && this.govtcandidateName) {
      this.matchStatus.studentName =
        this.studentName.trim().toUpperCase() ===
        this.govtcandidateName.trim().toUpperCase();
    } else {
      this.matchStatus.studentName = null;
    }
    // DOB CHECK

    if (this.dob && this.govtDB) {
      this.matchStatus.dob = this.dob.trim().toUpperCase() === this.govtDB.trim().toUpperCase();
    } else {
      this.matchStatus.dob = null;
    }

    // father name 

    if (this.parentName && this.govtfatherName) {
      this.matchStatus.parentName = this.parentName.trim().toUpperCase() === this.govtfatherName.trim().toUpperCase();
    } else {
      this.matchStatus.parentName = null;
    }
    // GENDER CHECK 

    if (this.displayGender && this.govtGender) {
      this.matchStatus.displayGender = this.displayGender.trim().toUpperCase() === this.govtGender.trim().toUpperCase();
    } else {
      this.matchStatus.displayGender = null;
    }

    if (this.motherName && this.govtmotherName) {
      this.matchStatus.motherName = this.motherName.trim().toUpperCase() === this.govtmotherName.trim().toUpperCase();
    } else {
      this.matchStatus.motherName = null;
    }
  }

  submit() {
    const payload = {
     'Application':this.govtApplicationNo,
     'Candidate name':this.govtcandidateName,
     'Dob':this.govtDB,
     'Father name':this.govtfatherName,
     'Gender':this.govtGender
    }
    console.log('As_per JEE Mains',payload);
    
  }


}


